module.exports = __webpack_public_path__ + "img/close-button.bff32920.svg";